const SKIP_PATHS = new Set([
  '/',
  '/login',
  '/login/partner',
  '/login-phone',
  '/login-otp',
  '/signup',
  '/forgot-password',
  '/vehicle-picker',
]);

export function shouldShowBack(pathname) {
  if (SKIP_PATHS.has(pathname)) return false;
  if (pathname.startsWith('/admin/')) return false;
  if (pathname.startsWith('/vendor/dashboard')) return false;
  if (pathname.startsWith('/mechanics/dashboard')) return false;
  if (pathname.startsWith('/garage/dashboard')) return false;
  if (pathname.startsWith('/shipping/dashboard')) return false;
  if (pathname.startsWith('/customer/dashboard')) return false;
  if (pathname.startsWith('/onboarding/')) return false;
  if (pathname.startsWith('/signup/')) return false;
  return true;
}

export function goBack(navigate) {
  if (window.history.length > 1) {
    navigate(-1);
  } else {
    navigate('/');
  }
}
